import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// This fucking hook should reset the scroll position to the top of the page
// when the route changes but it doesn't work properly. TO-DO: Fix it.
const useScrollReset = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
};

export default useScrollReset;
